import React from 'react';

export default function AgriPaper({ onCardClick }) {
  const cards = [
    { id: 1, label: 'කෘෂි අත් පත්‍රිකා', image: '/leaf.jpg', page: 'athpatrika' },
    { id: 2, label: 'විවිධ ආකෘති පත්‍රිකා', image: '/leaf.jpg', page: 'Govigivisum' },
    { id: 3, label: 'පුවත්පත්', image: '/leaf.jpg', page: 'puwatpat' },

  ];

  const handleCardClick = (page) => {
    if (onCardClick) {
      onCardClick(page);
    }
  };

  return (
    <section className="agripaper-section" aria-label="Agriculture Publications">
      <div className="agripaper-header">
        <h1 style={{ color: '#0b6b2f', fontSize: 28, marginBottom: 12, textAlign: 'justify' }}>භාගත කිරීම්</h1>
        <hr className="footer-sep" />
      </div>

      <div className="agripaper-cards-grid">
        {cards.map(card => (
          <div key={card.id} className="agripaper-card" onClick={() => handleCardClick(card.page)} style={{ cursor: 'pointer' }}>
            <div className="card-icon">
              <img src={card.image} alt={card.label} />
            </div>
            <div className="card-label">{card.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
